<template>
    <div class="categories-wrapper tw-flex tw-flex-wrap tw-justify-center tw-gap-2 sm:tw-gap-4">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
    import categories from '@/configs/categories';
    import { useWindowSize } from '@vueuse/core';

    const { width, height } = useWindowSize();

    const filteredCategories = categories.filter((category) => category.showInNews);

    const btnWidth = ref('33%');

    watch(
        [width, height],
        () => {
            if (width.value > 1024) {
                btnWidth.value = 100 / filteredCategories.length + '%';
            } else {
                btnWidth.value = 100 / Math.min(filteredCategories.length, 3) + '%';
            }
        },
        {
            immediate: true,
        },
    );
</script>

<style lang="scss">
    .categories-wrapper > * {
        width: calc(v-bind(btnWidth) - 0.5rem);
        @media (min-width: 640px) {
            width: calc(v-bind(btnWidth) - 1rem);
        }
    }
</style>
